var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeFun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1054 14.8941C15.0774 16.2301 13.5814 16.9971 12.0004 16.9971C10.4204 16.9971 8.9244 16.2311 7.8954 14.8941C7.6424 14.5661 7.7044 14.0961 8.0324 13.8431C8.3594 13.5901 8.8314 13.6511 9.0844 13.9791C9.8264 14.9441 10.8894 15.4971 12.0004 15.4971C13.1114 15.4971 14.1744 14.9441 14.9164 13.9801C15.1684 13.6501 15.6404 13.5901 15.9674 13.8421C16.2964 14.0951 16.3574 14.5661 16.1054 14.8941ZM19.9194 7.62505L14.3464 3.08505C12.9864 1.97505 11.0124 1.97605 9.6544 3.08505L4.0824 7.62405C3.2114 8.33005 2.7124 9.37706 2.7124 10.4971V17.6771C2.7124 19.9211 4.5394 21.7471 6.7844 21.7471H17.2154C19.4604 21.7471 21.2874 19.9211 21.2874 17.6771V10.4971C21.2874 9.37605 20.7884 8.33005 19.9194 7.62505Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFun);
export default __webpack_public_path__ + "static/media/home-fun.9b265cf2455cd8a22b04973158e9ad92.svg";
export { ForwardRef as ReactComponent };